import React from 'react';
import './PageLoader.css';

interface PageLoaderProps {
  label?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ label = 'Loading' }) => (
  <div className="page-loader" role="status" aria-live="polite" aria-label={label}>
    <div className="page-loader__track" aria-hidden="true">
      <span className="page-loader__bar" />
    </div>
    <p className="page-loader__label">{label}</p>
  </div>
);

export default PageLoader;
